import Echo, { type Broadcaster } from 'laravel-echo'

import { useDisciplineStore } from '@stores/discipline'

import { useStopListener } from '@ws/stop-listener.hook'
import { useListenEventFiles } from '@ws/listen-new-files.hook'

export const useListenDisciplineChannel = ($echo: Echo<keyof Broadcaster>): void => {
  const disciplineStore = useDisciplineStore()

  if (disciplineStore.activeDiscipline?.id) {
    const name = `cs.discipline.${disciplineStore.activeDiscipline.id}`
    const channel = $echo.private(name)

    useListenEventFiles(channel)
    useStopListener($echo, name, channel)
  }
}
